import React from 'react';
const PostSalesFilled = props => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" {...props} className="pb-core-components-Icon-icon--Icon" role="img" focusable="false" aria-hidden="true">
    <defs>
      <path d="M12 0H0v18h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm.8 16c0 .441-.359.8-.8.8H1.2V1.2H12c.441 0 .8.359.8.8v14zM3 5.2h8V4H3v1.2zM8 14h3v-1.2H8V14zm7.2-9.526v1.294l1.238.5L15.2 9.332v3.204l2.8-6.93-2.8-1.132z" id="PostSalesFilled"></path>
    </defs>

    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="System-icons/-Dashboard-/-Active">
        <rect id="Container" fill="#FFFFFF" fillRule="evenodd" opacity="0" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2" fill="white">
          <use xlinkHref="#PostSalesFilled"></use>
        </mask>
        <use id="Icon-colour" fill="#DB0011" fillRule="evenodd" xlinkHref="#PostSalesFilled"></use>
      </g>
    </g>
  </svg>
);

export default React.memo(PostSalesFilled);